import React from 'react';
import { connect, batch } from 'react-redux';

import {
    toggleIsFetchingPurposeFlag,
    fetchDemoPurposeForRoleTemplate,
    updateRoleTemplateDemoPurpose
} from '../../actions';
import RoleTemplatesTable from '../common/RoleTemplatesTable';
import SearchFilter from '../common/SearchFilter';
import pushMessage from '../common/PushMessage';
import CONFIG from '../../config';

class RoleTemplateDemoPurpose extends React.Component {

    getFilterDropDown = (filterProps, dataIndex) => {
        const { setSelectedKeys, selectedKeys, confirm, clearFilters } = filterProps;
        return (
            <SearchFilter
                dataIndex={dataIndex}
                searchString={selectedKeys[0]}
                setSearchString={setSelectedKeys}
                confirm={confirm}
                handleClear={this.handleClear}
                handleSearch={this.handleFilter}
                clearFilters={clearFilters}
            />
        )
    }

    columnFilters = {
        filterDropdown: (filterProps) => this.getFilterDropDown(filterProps, "purpose"),
        sorter: true
    }

    filterSort = {}

    handleFilter = (purpose, confirm) => {
        purpose = purpose?.trim();
        if (!purpose && !this.filterSort.filter) {
            pushMessage(CONFIG.messageType.warning, "Please enter a search string")
            return;
        }
        else confirm()
    }

    handleClear = (clearFilters) => {
        clearFilters();
    }

    handleChange = (pagination, filters, sorter) => {

        this.filterSort = {
            filter: filters.purpose?.[0] ? { purpose: filters.purpose[0] } : undefined,
            sort: sorter.columnKey
                ? {
                    [sorter.columnKey]: CONFIG.sortMap[sorter.order]
                }
                : undefined
        }

        batch(() => {
            this.props.toggleIsFetchingPurposeFlag(true);
            this.props.fetchDemoPurposeForRoleTemplate({
                pageNumber: pagination.current,
                pageSize: (CONFIG.shortPageSize + 1),
                access: this.access,
                filterSort: this.filterSort
            });
        });
    }

    componentDidMount() {
        const { userRoleTemplate } = this.props;
        this.access = userRoleTemplate.templateType === CONFIG.roleTypes.admin ? CONFIG.roleTemplateAccess.fullAccess : undefined;
        this.props.toggleIsFetchingPurposeFlag(true);
        this.props.fetchDemoPurposeForRoleTemplate({ access: this.access });
    }

    render() {
        const { demoPurpose, count, assignedDemoPurposes, isFetching, allDemoPurposeAdminAccess, allDemoPurposeUserAccess, updateRoleTemplateDemoPurpose, templateType } = this.props;
        return (
            <RoleTemplatesTable
                dataKey="demoPurpose"
                dataIndex="purpose"
                hideColumns={templateType === CONFIG.roleTypes.admin ? [] : ['admin']}
                marginTop={true}
                bordered={true}
                data={demoPurpose}
                selectAllDisabled={this.filterSort.filter !== undefined}
                columnFilters={this.columnFilters}
                onChange={this.handleChange}
                pagination={{
                    pageSize: CONFIG.shortPageSize + 1,
                    total: count
                }}
                isFetching={isFetching}
                assignedData={assignedDemoPurposes}
                allAdminAccess={allDemoPurposeAdminAccess}
                allUserAccess={allDemoPurposeUserAccess}
                updateRoleTemplateData={(updateRoleTemplateDemoPurpose)}
            />
        );
    }
}

const mapStateToProps = ({ demoPurpose, roleTemplate, user }) => {
    return {
        demoPurpose: demoPurpose.demoPurposes,
        count: demoPurpose.count,
        isFetching: demoPurpose.isFetching,
        assignedDemoPurposes: roleTemplate.demoPurposes,
        allDemoPurposeUserAccess: roleTemplate.allDemoPurposeUserAccess,
        allDemoPurposeAdminAccess: roleTemplate.allDemoPurposeAdminAccess,
        templateType: roleTemplate.templateType,
        userRoleTemplate: user.profile ? user.profile.roleTemplate : undefined,
        roleTemplate
    }
}

export default connect(
    mapStateToProps,
    {
        toggleIsFetchingPurposeFlag,
        fetchDemoPurposeForRoleTemplate,
        updateRoleTemplateDemoPurpose
    }
)(RoleTemplateDemoPurpose);